import { CannedQuestionName } from '../../api/models/survey';
import { BUYER_ATTENDEE_ID, CHECKOUT_FORM_NAME } from '../../constants';
import { QUESTIONS_FOR_PAYMENT } from '../../models/survey';
import { CheckoutState } from '../../state';
import { isRequiredQuestion } from '../../utils/surveys';
import { getFormValues } from '../forms';
import { getSurvey } from './survey';

export const hasUnansweredRequiredQuestions = (state: CheckoutState) => {
    const formData = getFormValues(state, CHECKOUT_FORM_NAME);
    const { questionsForAttendees, questionsForBuyer } = getSurvey(state);

    const hasUnansweredRequiredBuyerQuestion = questionsForBuyer.some(
        (question) =>
            isRequiredQuestion(question, questionsForBuyer) &&
            !QUESTIONS_FOR_PAYMENT.includes(
                question.name as CannedQuestionName,
            ) &&
            !(question.name in (formData[BUYER_ATTENDEE_ID] ?? {})),
    );

    const hasUnansweredRequiredAttendeeQuestion = questionsForAttendees.some(
        ({ id, survey }) =>
            survey.some(
                (question) =>
                    isRequiredQuestion(question, survey) &&
                    !(question.name in (formData[id] ?? {})),
            ),
    );

    return (
        hasUnansweredRequiredBuyerQuestion ||
        hasUnansweredRequiredAttendeeQuestion
    );
};
